import { ref } from 'vue';

// Estado global compartilhado
const isInternalChatOpen = ref(false);

export function useInternalChat() {
  const openInternalChat = () => {
    isInternalChatOpen.value = true;
  };

  const closeInternalChat = () => {
    isInternalChatOpen.value = false;
  };

  const toggleInternalChat = () => {
    isInternalChatOpen.value = !isInternalChatOpen.value;
  };

  return {
    isInternalChatOpen,
    openInternalChat,
    closeInternalChat,
    toggleInternalChat,
  };
}
